import type { Microgame } from '@pose-game/core';
import { chomp } from './01-chomp.js';
import { ninjaSlice } from './02-ninja-slice.js';
import { dodgeTilt } from './03-dodge-tilt.js';
import { squatGate } from './04-squat-gate.js';
import { smileHold } from './05-smile-hold.js';
import { pointMole } from './06-point-mole.js';
import { freeze } from './07-freeze.js';
import { castCombo } from './08-cast-combo.js';
import { boxing } from './09-boxing.js';
import { poseTetris } from './10-pose-tetris.js';

export {
  chomp,
  ninjaSlice,
  dodgeTilt,
  squatGate,
  smileHold,
  pointMole,
  freeze,
  castCombo,
  boxing,
  poseTetris,
};

export const defaultRun: Microgame[] = [
  chomp,
  ninjaSlice,
  dodgeTilt,
  squatGate,
  smileHold,
  pointMole,
  freeze,
  castCombo,
  boxing,
  poseTetris,
];
